
<template>
  <svg viewBox="0 0 191.74 191.79" :height="height" :width="width" xmlns="http://www.w3.org/2000/svg">
    <title>Resources Info</title>
    <path
        d="M0,95.88C.17,43.03,42.57,.04,96.03,0c52.9-.04,95.67,43.05,95.71,95.91,.05,51.92-41.78,95.81-95.99,95.88C42.92,191.85-.04,148.62,0,95.88Zm169.94,0c-.05-43.17-30.89-74.11-74.01-74.01-42.55,.1-73.97,29.36-74.03,73.92-.07,44.53,31.3,74.05,74.08,74.13,43.11,.09,74.01-30.94,73.96-74.04Z"/>
    <path
        d="M86.86,125.96v-23.93c-1.39-.14-.71-.16-1.99-.41-4.9-.92-7.71-4.09-7.77-8.63-.06-4.62,2.79-9.24,7.83-9.76,4.61-.48,7.25,.02,11.94,.02,10.04,0,11.82,4.95,11.85,10.26,.05,9.83,.02,19.66,.02,29.5v2.95c2.1,0,1.91-.07,3.72,.01,5.52,.27,8.2,3.82,8.25,8.84,.05,4.94-6.43,12.81-11.84,12.93-9.99,.24-18,.24-27.99,0-5.4-.13-8.86-8.03-8.78-12.98,.08-4.96,3.63-8.45,9.03-8.79,1.82-.11,3.64-.01,5.73-.01Z"/>
    <path
        d="M109.74,59.81c.02,7.01-6.89,14-13.82,14.02-6.9,.02-13.92-7.04-13.89-13.98,.03-6.86,6.93-13.83,13.73-13.89,6.94-.08,13.96,6.89,13.98,13.85Z"/>
  </svg>
</template>
<script>
export default {
  name: 'IconResourceInfoBall',
  props: {
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
  },
};
</script>
